<template>
  <p class="lead">Oturum açma sayfasına yönlendiriliyorsunuz...</p>
</template>
<script>
/* eslint-disable */
import sha256 from 'crypto-js/sha256'
import base64URL from 'crypto-js/enc-base64'

export default {
  name: 'LoginRequiredPage',
  data() {
    return {
      code_verifier: '',
      code_challenge: '',
      code_challenge_method: 'S256',
      state: ''
    }
  },
  methods: {
    generateRandomString(length) {
      let text = "";
      let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
      for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    generateCodeChallenge(code_verifier) {
      return this.genereateBase64URL(sha256(code_verifier))
    },
    genereateBase64URL(string) {
      return string.toString(base64URL).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
    },
    prepareAuthUrl() {
      let authorizationEndpoint = 'https://localhost:5001/connect/authorize?'
      let authBody = {
        "code_challenge": "",
        "code_challenge_method": "S256",
        "redirect_uri": "http://localhost:8080/callback",
        "response_type": "code",
        "scope": "api1",
        "client_id": "spa"
      }

      this.code_verifier = this.generateRandomString(128)
      this.code_challenge = this.generateCodeChallenge(this.code_verifier)

      console.log('code verifaya : ' + this.code_verifier)
      this.state = this.generateRandomString(32)
      localStorage.setItem(this.state, this.code_verifier)

      let authUrl = authorizationEndpoint + 
      "response_type=code&client_id=spa&scope=api1&code_challenge=" + this.code_challenge
      + "&code_challenge_method=S256&redirect_uri=http://localhost:8080/callback&state=" + this.state;

      window.location = authUrl
    }
  },
  mounted() {
    console.log('created loginRequiredPage')
    this.prepareAuthUrl()
  }
}

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LoginRequiredPage.vue